import { render, staticRenderFns } from "./ot-currency-field.vue?vue&type=template&id=0fd200ee&scoped=true&"
import script from "./ot-currency-field.vue?vue&type=script&lang=ts&"
export * from "./ot-currency-field.vue?vue&type=script&lang=ts&"
import style0 from "./ot-currency-field.vue?vue&type=style&index=0&id=0fd200ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd200ee",
  null
  
)

export default component.exports